{
  "common.close": "ปิด",
  "common.athleteFallback": "นักกีฬา {id}",
  "splash.title": "{app} — แสดงกิจกรรมเป็นภาพเคลื่อนไหว",
  "splash.tagline": "ข้อมูล Strava&nbsp;ของคุณในแบบเคลื่อนไหว",
  "splash.demo": "สาธิต",
  "tab.query.title": "แผนที่ของ {name}",
  "tab.query.heading": "ค้นหากิจกรรม:",
  "tab.query.optDays": "วันล่าสุด",
  "tab.query.optActivities": "กิจกรรมล่าสุด",
  "tab.query.optIds": "ID กิจกรรม",
  "tab.query.optDates": "ช่วงวันที่",
  "tab.query.idsPlaceholder": "ใส่ ID กิจกรรมที่นี่",
  "tab.query.after": "ตั้งแต่:",
  "tab.query.before": "ถึง:",
  "tab.query.autozoom": "ซูม <i class=\"hf hf-bullseye\"></i> ไปยังผลการค้นหาอัตโนมัติหลังนำเข้า",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> ค้นหา",
  "tab.query.createAccount": "สร้างบัญชีและ/หรือเข้าสู่ระบบ",
  "tab.query.sports": "กีฬา:",
  "tab.query.allSports": "กีฬาทั้งหมด",
  "tab.query.sportsExcept": "ทั้งหมดยกเว้น",
  "tab.query.sportsNone": "ไม่มี",
  "tab.query.loadingSports": "กำลังโหลดกีฬา…",
  "tab.query.sportsFailed": "โหลดกีฬาของแผนที่นี้ไม่ได้",
  "tab.query.noSports": "ยังไม่มีกิจกรรม",
  "tab.activities.title": "กิจกรรมที่แสดงอยู่",
  "tab.activities.clearSelection": "ล้างการเลือก",
  "tab.activities.renderSelected": "แสดงที่เลือก",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> ซูมไปยังที่เลือก",
  "tab.controls.title": "ตั้งค่าเลเยอร์",
  "tab.controls.timescale": "มาตราเวลา <i>&tau;</i>",
  "tab.controls.timescaleHint": "ความเร็วในการเล่น",
  "tab.controls.period": "คาบ <i>T</i>",
  "tab.controls.periodHint": "กิจกรรม ~ แบบจำลอง",
  "tab.controls.dotSize": "ขนาดจุด",
  "tab.controls.pathWidth": "ความกว้างเส้นทาง",
  "tab.controls.pathWidthHint": "ศูนย์จะซ่อนเส้นทาง",
  "tab.controls.colors": "สี",
  "tab.controls.colorsHint": "หมุนชุดสี",
  "tab.controls.shadows": "เงา",
  "tab.profile.loginTitle": "เข้าสู่ระบบ",
  "tab.profile.anonNote": "เข้าสู่ระบบด้วย Strava เพื่อดูกิจกรรมของคุณเองและจัดการบัญชี Heatflask ของคุณ",
  "tab.profile.loginLink": "เข้าสู่ระบบด้วย Strava",
  "tab.profile.editOnStrava": "แก้ไขโปรไฟล์บน Strava",
  "tab.profile.indexNote": "เราจัดทำดัชนีสรุปกิจกรรมของคุณเพื่อให้เข้าถึงได้รวดเร็ว",
  "tab.profile.viewIndex": "ดูดัชนี",
  "tab.profile.sharedMaps": "แชร์แผนที่",
  "tab.profile.sharedMapsNote": "ปิด: มีเพียงคุณที่เห็นกิจกรรมของคุณบน Heatflask เปิด: ทุกคนที่มีลิงก์แผนที่ของคุณจะเห็นกิจกรรมที่คุณตั้งเป็นสาธารณะบน Strava ส่วนกิจกรรมส่วนตัวจะยังเป็นของคุณคนเดียวไม่ว่ากรณีใด <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">ความเป็นส่วนตัวทำงานอย่างไร</a>",
  "tab.profile.logout": "ออกจากระบบ",
  "tab.profile.deleteAccount": "ลบบัญชี",
  "tab.profile.deleteConfirm": "ลบบัญชี Heatflask ของคุณหรือไม่?\n\nการดำเนินการนี้จะลบกิจกรรมที่จัดทำดัชนีไว้ และเพิกถอนสิทธิ์ของ Heatflask ในการเข้าถึงข้อมูล Strava ของคุณ ไม่สามารถย้อนกลับได้",
  "tab.profile.languageHeading": "ภาษา",
  "tab.profile.languageAuto": "อัตโนมัติ",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">ช่วยเราแก้ไขหรือเพิ่มคำแปลใหม่!</a>",
  "tab.profile.unitsHeading": "หน่วย",
  "tab.profile.unitsAuto": "อัตโนมัติ",
  "tab.profile.unitsMetric": "เมตริก (km, m)",
  "tab.profile.unitsImperial": "อิมพีเรียล (mi, ft)",
  "tab.profile.textSizeHeading": "ขนาดตัวอักษร",
  "tab.profile.textSmaller": "เล็กลง",
  "tab.profile.textReset": "ปกติ",
  "tab.profile.textLarger": "ใหญ่ขึ้น",
  "tab.profile.mapDefaultsHeading": "ค่าเริ่มต้นของแผนที่",
  "tab.profile.mapDefaultsNote": "เริ่มต้นด้วยแผนที่ฐาน ภูมิประเทศ และการตั้งค่าเลเยอร์นี้ทุกครั้งที่คุณเปิดแผนที่ที่ลิงก์ไม่ได้กำหนดไว้เอง ลิงก์ที่คุณแชร์ยังคงแสดงตรงตามที่คุณเห็น",
  "tab.profile.mapDefaultsSave": "บันทึกเป็นค่าเริ่มต้นของฉัน",
  "tab.profile.mapDefaultsForget": "ลืม",
  "tab.info.title": "ข้อมูล",
  "tab.info.controlsHeading": "การควบคุม",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + ลาก",
  "tab.info.shiftDragDesc": "เลือกกิจกรรมในกรอบสี่เหลี่ยม บนหน้าจอสัมผัส ให้แตะ <i class=\"hf-object-group\"></i> ก่อน แล้วลากด้วยนิ้วเดียว กิจกรรมที่เลือกล่าสุดจะแสดงรายละเอียด และรายการกิจกรรมจะเลื่อนไปที่กิจกรรมนั้น",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + ลาก",
  "tab.info.ctrlDragDesc": "หมุนและเอียงแผนที่แบบ 3 มิติ หรือใช้สองนิ้ว",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "เปิดหรือปิดแถบด้านข้าง",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "แท็บก่อนหน้าหรือถัดไป",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "ปิดแถบด้านข้าง",
  "tab.info.liveUrlHeading": "URL สด",
  "tab.info.liveUrlDesc": "มุมมองแผนที่และการตั้งค่าภาพเคลื่อนไหวถูกเก็บไว้ใน URL ของหน้า ใครก็ตามที่คุณแชร์ให้จะเห็นมุมมองเดียวกัน",
  "tab.info.videoHeading": "ส่งออกวิดีโอ",
  "tab.info.videoDesc": "ปุ่ม <i class=\"hf-video-camera\"></i> จะบันทึกภาพเคลื่อนไหวเป็น MP4: แตะปุ่ม วางกรอบบนส่วนของแผนที่ที่ต้องการ แล้วแตะอีกครั้งเพื่อบันทึก ระบบจะบันทึกภาพเคลื่อนไหวครบหนึ่งรอบ วิดีโอจึงเล่นวนได้ต่อเนื่อง หากหนึ่งรอบยาวกว่า {max} วินาที (ความยาววิดีโอสูงสุดที่ Strava รับ) จะถูกตัดที่ {max} วินาที",
  "tab.info.contributeHeading": "ร่วมพัฒนา",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> สนับสนุนบน GitHub",
  "tab.info.contactsHeading": "ติดต่อ",
  "map.basemapAndTerrain": "แผนที่พื้นฐานและภูมิประเทศ",
  "map.pauseAnimation": "หยุดภาพเคลื่อนไหวชั่วคราว",
  "map.resumeAnimation": "เล่นภาพเคลื่อนไหวต่อ",
  "capture.record": "บันทึกวิดีโอ (รอบละ {period} วินาที)",
  "capture.recordTruncated": "บันทึกวิดีโอ (หนึ่งรอบยาว {period} วินาที; จะบันทึกเพียง {max} วินาทีแรก)",
  "capture.recordArea": "บันทึกพื้นที่ภายในกรอบ",
  "capture.stop": "หยุดบันทึก",
  "capture.selectionTooSmall": "พื้นที่ที่เลือกเล็กเกินไป",
  "capture.saved": "บันทึก {name} แล้ว ({size})",
  "capture.cancelled": "ยกเลิกการบันทึกแล้ว",
  "capture.failed": "บันทึกไม่สำเร็จ: {error}",
  "capture.loadingEncoder": "กำลังโหลดตัวเข้ารหัส…",
  "capture.waitingForMap": "กำลังรอแผนที่โหลด…",
  "capture.encoding": "กำลังเข้ารหัส… {percent}%",
  "capture.finalizing": "กำลังเสร็จสิ้น…",
  "share.title": "แชร์ลิงก์ของแผนที่นี้",
  "share.copied": "คัดลอกลิงก์แล้ว",
  "share.copiedUnshared": "คัดลอกลิงก์แล้ว แต่แผนที่ของคุณยังไม่ได้แชร์ คนอื่นจึงเปิดไม่ได้ เปิด “แชร์แผนที่” เพื่อเปลี่ยน",
  "share.unshared": "แผนที่ของคุณยังไม่ได้แชร์ คนอื่นจึงเปิดลิงก์นี้ไม่ได้ เปิด “แชร์แผนที่” เพื่อเปลี่ยน",
  "share.copyThis": "คัดลอกลิงก์นี้:",
  "update.available": "มี Heatflask เวอร์ชันใหม่แล้ว",
  "update.reload": "โหลดใหม่",
  "import.title": "กำลังนำเข้า",
  "import.stop": "หยุด",
  "import.stopping": "กำลังหยุด…",
  "import.contacting": "กำลังเชื่อมต่อ Strava…",
  "import.countOf": "{received} จาก {total} กิจกรรม",
  "import.count": "{received} กิจกรรม",
  "import.waitStrava": "หยุดชั่วคราวถึง {time} เนื่องจากขีดจำกัดการดาวน์โหลดของ Strava เปิดหน้านี้ไว้ การโหลดใหม่ไม่ช่วยให้เร็วขึ้น",
  "import.waitRationed": "ใช้การดาวน์โหลดแบบเร็วของวันนี้หมดแล้ว ส่วนที่เหลือจะดำเนินต่อเวลา {time} แต่ช้ากว่า เปิดหน้านี้ไว้",
  "import.dailyLimit": "ถึงขีดจำกัดการดาวน์โหลดรายวันของ Strava แล้ว ลองใหม่หลัง {time}",
  "import.dailyRationed": "คุณใช้โควตาการดาวน์โหลดจาก Strava ของวันนี้หมดแล้ว ลองใหม่หลัง {time}",
  "import.noActivitiesYet": "บัญชี Strava ของคุณยังไม่มีกิจกรรม บันทึกหรืออัปโหลดกิจกรรมบน Strava แล้วกิจกรรมจะแสดงที่นี่",
  "table.noActivities": "ไม่มีกิจกรรม",
  "table.untitled": "(ไม่มีชื่อ)",
  "activities.pageTitle": "{app} — ดัชนีกิจกรรม",
  "activities.heading": "ดัชนีกิจกรรม",
  "activities.fetching": "กำลังดึงกิจกรรม...",
  "activities.rateLimit": "ถึงขีดจำกัดคำขอของ Strava แล้ว; จะทำต่อเวลา {time}",
  "activities.noData": "ขออภัย ไม่มีข้อมูล &#128577;",
  "activities.colServerCache": "เส้นทางแคชไว้บนเซิร์ฟเวอร์ (Mongo)",
  "activities.colBrowserCache": "เส้นทางแคชไว้ในเบราว์เซอร์นี้",
  "activities.cachedServer": "เส้นทางของ {id} แคชไว้บนเซิร์ฟเวอร์แล้ว",
  "activities.notCachedServer": "เส้นทางของ {id} ยังไม่ได้แคชไว้บนเซิร์ฟเวอร์",
  "activities.cachedBrowser": "เส้นทางของ {id} แคชไว้ในเบราว์เซอร์นี้แล้ว",
  "activities.notCachedBrowser": "เส้นทางของ {id} ยังไม่ได้แคชไว้ในเบราว์เซอร์นี้",
  "sport.AlpineSki": "สกีลงเขา",
  "sport.BackcountrySki": "สกีนอกเส้นทาง",
  "sport.Badminton": "แบดมินตัน",
  "sport.Basketball": "บาสเกตบอล",
  "sport.Canoeing": "พายเรือแคนู",
  "sport.Cricket": "คริกเก็ต",
  "sport.Crossfit": "ครอสฟิต",
  "sport.Dance": "เต้นรำ",
  "sport.EBikeRide": "ปั่นจักรยานไฟฟ้า",
  "sport.Elliptical": "เครื่องเดินวงรี",
  "sport.EMountainBikeRide": "ปั่นเสือภูเขาไฟฟ้า",
  "sport.Golf": "กอล์ฟ",
  "sport.GravelRide": "ปั่นกรวด",
  "sport.Handcycle": "จักรยานมือหมุน",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "เดินป่า",
  "sport.IceSkate": "สเก็ตน้ำแข็ง",
  "sport.InlineSkate": "อินไลน์สเก็ต",
  "sport.Kayaking": "พายเรือคายัค",
  "sport.Kitesurf": "ไคท์เซิร์ฟ",
  "sport.MountainBikeRide": "ปั่นเสือภูเขา",
  "sport.NordicSki": "สกีทางเรียบ",
  "sport.Padel": "พาเดล",
  "sport.PhysicalTherapy": "กายภาพบำบัด",
  "sport.Pickleball": "พิกเกิลบอล",
  "sport.Pilates": "พิลาทิส",
  "sport.Racquetball": "แร็กเก็ตบอล",
  "sport.Ride": "ปั่นจักรยาน",
  "sport.RockClimbing": "ปีนผา",
  "sport.RollerSki": "โรลเลอร์สกี",
  "sport.Rowing": "พายเรือ",
  "sport.Run": "วิ่ง",
  "sport.Sail": "แล่นเรือใบ",
  "sport.Skateboard": "สเก็ตบอร์ด",
  "sport.Snowboard": "สโนว์บอร์ด",
  "sport.Snowshoe": "เดินรองเท้าหิมะ",
  "sport.Soccer": "ฟุตบอล",
  "sport.Squash": "สควอช",
  "sport.StairStepper": "เครื่องก้าวขึ้นบันได",
  "sport.StandUpPaddling": "ยืนพายบอร์ด",
  "sport.Surfing": "โต้คลื่น",
  "sport.Swim": "ว่ายน้ำ",
  "sport.TableTennis": "เทเบิลเทนนิส",
  "sport.Tennis": "เทนนิส",
  "sport.TrailRun": "วิ่งเทรล",
  "sport.Velomobile": "เวโลโมบิล",
  "sport.VirtualRide": "ปั่นจักรยานเสมือน",
  "sport.VirtualRow": "พายเรือเสมือน",
  "sport.VirtualRun": "วิ่งเสมือน",
  "sport.Volleyball": "วอลเลย์บอล",
  "sport.Walk": "เดิน",
  "sport.WeightTraining": "เวทเทรนนิ่ง",
  "sport.Wheelchair": "วีลแชร์",
  "sport.Windsurf": "วินด์เซิร์ฟ",
  "sport.Workout": "ออกกำลังกาย",
  "sport.Yoga": "โยคะ"
}
